import { useMemo } from 'react';
import { LegendMode } from '@/core';
import { TimeSeriesChartProps } from '../time-series-chart-model';

export interface UseTimeSeriesLabelsToColumnsProps
  extends Pick<TimeSeriesChartProps, 'enableLabelsToColumns'>,
    Pick<Required<TimeSeriesChartProps>, 'showToggleMode'> {
  legendMode?: LegendMode;
}
export interface UseTimeSeriesLabelsToColumnsResponse {
  enableLabelsToColumns: boolean;
}

/**
 * Hook to help with use of the "labels to columns" feature in the time series chart.
 */
export const useTimeSeriesLabelsToColumns = ({
  enableLabelsToColumns: initEnableLabelsToColumns,
  showToggleMode,
  legendMode,
}: UseTimeSeriesLabelsToColumnsProps): UseTimeSeriesLabelsToColumnsResponse => {
  const enableLabelsToColumns: boolean = useMemo(() => {
    // Labels-to-columns is supported when the legend is shown in a table or could toggle to a table.
    const labelsToColumnsSupported = legendMode === 'Table' || showToggleMode;

    // Enable labels-to-columns when it is programmatically enabled AND
    // it is supported by the other configuration.
    return !!initEnableLabelsToColumns && labelsToColumnsSupported;
  }, [initEnableLabelsToColumns, legendMode, showToggleMode]);

  return {
    enableLabelsToColumns,
  };
};
